export default __webpack_public_path__ + "static/media/finance-aragonaio.c7bec374.png";